/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber1Small = createReactComponent("outline", "number-1-small", "IconNumber1Small", [["path", { "d": "M10 10l2 -2v8", "key": "svg-0" }]]);

export { IconNumber1Small as default };
//# sourceMappingURL=IconNumber1Small.mjs.map
